<template>
  <div class="w-100 mw-100 overflow-x-auto">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th v-if="hasPermission($store.state.user, 'SESSIONS_WRITE')">
            <i
              class="fa fa-info-circle"
              v-tooltip="
                `Lorsque cette option est désactivé, les séances ne sont pas planifiables par le coach dans l'app mobile.`
              "
            ></i>
          </th>
          <th v-if="hasPermission($store.state.user, 'SESSIONS_WRITE')">
            <input
              v-if="sessions.length > 1"
              type="checkbox"
              class="cursor-pointer"
              @click="toggleSelected"
            />
          </th>
          <th>Séance</th>
          <th v-if="!coach">Coach</th>
          <th v-if="client">Client</th>
          <th>Credit</th>
          <th>Durée</th>
          <th>Attribuée le</th>
          <th>Programmée le</th>
          <th>Statut</th>
          <th>Code</th>
          <th v-if="visio">Visio</th>
          <th v-if="showNbOfParticipants">Pointage</th>
          <th v-if="oneOrMoreHasSignatureSheet" align="center">Émargement</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(session, index) in sessions" :key="index">
          <td
            v-if="hasPermission($store.state.user, 'SESSIONS_WRITE')"
            width="25"
          >
            <i
              v-if="session.sessionCoachBlocked"
              class="text-danger fa fa-exclamation-circle cursor-pointer"
              @click="unlockSessionCoach(session)"
            />
            <i v-else class="text-success fa fa-check-circle" />
          </td>
          <td v-if="hasPermission($store.state.user, 'SESSIONS_WRITE')">
            <input
              v-if="sessions.length > 1"
              v-model="selected"
              type="checkbox"
              class="cursor-pointer"
              :value="session.id"
              :disabled="
                session.disbursed ||
                (session.completed && !isAdmin($store.state.user))
              "
            />
          </td>
          <td @click="editCoachs = null">
            #{{ session.counter }}
            <i v-if="session.free" class="fa fa-gift text-info"></i>
          </td>
          <td
            v-if="
              (hasPermission($store.state.user, 'SESSIONS_WRITE') ||
                isAdmin($store.state.user)) &&
              !client &&
              !session.disbursed
            "
            class="editable"
            @click="editCoachs = session.id"
          >
            <span
              v-if="editCoachs !== session.id"
              v-html="coachsLinks(session)"
            ></span>
            <v-select
              v-else-if="coachsId"
              :options="coachsId"
              :value="sessionCoachs(editCoachs)"
              @input="saveCoachs"
              multiple
            />
          </td>
          <td v-else-if="!coach" v-html="coachsLinks(session)"></td>

          <td v-if="client">
            <router-link
              v-if="session.client"
              :to="'/clients/' + session.client.id"
              >{{ session.client.fullName }}</router-link
            >
            <div v-else>erreur : {{ session.id }}</div>
          </td>
          <td
            v-if="
              !session.disbursed &&
              !session.completed &&
              hasPermission($store.state.user, 'SESSIONS_WRITE')
            "
            class="editable"
            @click="editCredit = session.id"
          >
            <div v-if="session.assignedAt">
              <span v-if="editCredit !== session.id">{{
                formatPrice(session.credit, true)
              }}</span>
              <input
                type="text"
                class="form-control"
                v-on:keyup.enter="saveCredit($event)"
                :value="formatPrice(session.credit, true, true)"
                v-else
              />
            </div>
          </td>
          <td v-else>{{ formatPrice(session.credit, true) }}</td>
          <td
            v-if="
              !session.disbursed &&
              !session.completed &&
              hasPermission($store.state.user, 'SESSIONS_WRITE')
            "
            class="editable"
            @click="
              (editDuration = session.id),
                (form.duration = formatDuration(session.duration, false))
            "
          >
            <span v-if="editDuration !== session.id">{{
              formatDuration(session.duration)
            }}</span>
            <el-time-select
              v-else
              v-model="form.duration"
              @change="saveDuration"
              size="mini"
              :clearable="false"
              :picker-options="{
                start: '00:10',
                step: '00:05',
                end: '02:00',
              }"
            />
          </td>
          <td v-else>{{ formatDuration(session.duration) }}</td>
          <td>
            <span
              v-if="
                !session.disbursed &&
                hasPermission($store.state.user, 'SESSIONS_WRITE')
              "
              @click="editAssignedDate(session)"
              >{{ formatDate(session.assignedAt) }}</span
            >
            <span v-else>{{ formatDate(session.assignedAt) }}</span>
          </td>
          <td>
            <span
              v-if="
                !session.disbursed &&
                hasPermission($store.state.user, 'SESSIONS_WRITE')
              "
              @click="editScheduledDate(session)"
              >{{ formatDateTime(session.scheduledAt) }}</span
            >
            <span v-else>{{ formatDateTime(session.scheduledAt) }}</span>
          </td>
          <td>
            <span
              v-if="session.completed && session.disbursed"
              class="badge badge-success"
            >
              <i class="icon-check"></i>
              Séance payée<span v-if="session.scheduledBy">
                &ndash; effectuée par {{ session.scheduledBy.coach.name }}</span
              >
            </span>
            <div v-else-if="session.completed">
              <span
                class="badge badge-success cursor-pointer"
                @click="saveDone(session)"
              >
                Terminée<span v-if="session.scheduledBy">
                  et validée par {{ session.scheduledBy.coach.name }}</span
                >
              </span>
              <span
                v-if="session.userMark && session.userMark.notCompleted"
                class="ml-1 text-danger border-danger"
              >
                Contesté
                <span v-if="session.userMark.markedAt"
                  >le {{ formatDate(session.userMark.markedAt) }}</span
                >
              </span>
            </div>
            <span
              class="badge badge-info cursor-pointer"
              v-else-if="session.scheduledAt"
              @click="saveDone(session)"
            >
              Programmée<span v-if="session.scheduledBy">
                par {{ session.scheduledBy.coach.name }}</span
              >
            </span>
            <span
              class="badge badge-warning cursor-pointer"
              v-else-if="session.assignedAt"
              @click="saveDone(session)"
              >Non programmée</span
            >
            <span class="badge badge-danger" v-else>Non attribuée</span>
          </td>
          <td>{{ session.validationCode || "-" }}</td>
          <td v-if="visio">
            <button class="btn btn-info" @click="handleSendVisioLink(session)">
              <i class="fa fa-video-camera"></i>
              Envoyer les liens visio
            </button>
          </td>
          <td v-if="showNbOfParticipants" style="width: 100px">
            <input
              class="form-control"
              type="number"
              v-model="session.nbOfParticipants"
              min="0"
              step="1"
              @change="
                (e) => changeSessionNbOfParticipants(e.target.value, session)
              "
              v-if="hasPermission($store.state.user, 'SESSIONS_WRITE')"
              :disabled="!session.scheduledAt || session.disbursed"
            />
          </td>
          <td v-if="oneOrMoreHasSignatureSheet">
            <template v-if="session.signatureSheet">
              <SignatureSheetStatusBadge
                :status="session.signatureSheet.status"
              />

              <div
                v-if="
                  hasPermission($store.state.user, 'COMPANIES_COMPANY_READ') ||
                  hasPermission($store.state.user, 'PUBLIC_PROCUREMENTS_READ')
                "
                class="d-flex"
                style="margin-top: 5px; gap: 5px"
              >
                <button
                  class="btn btn-sm btn-outline-secondary"
                  @click="displaySessionSignatureSheet = session"
                >
                  <i class="fa fa-eye"></i>
                </button>
                <SignatureSheetDownloadButton
                  :signature-sheet="session.signatureSheet"
                />
              </div>
            </template>
            <span v-else> - </span>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="selected.length">
        <tr>
          <td colspan="8">
            <button
              v-if="!disableEdition"
              class="btn btn-link text-danger btn-sm float-right"
              @click="handleRemoveSession"
            >
              Supprimer les séances non programmées du pack
            </button>
            <button
              class="btn btn-secondary btn-sm"
              @click="editSelected = true"
              v-if="hasPermission($store.state.user, 'SESSIONS_WRITE')"
            >
              Modifier {{ selected.length === 1 ? "la séance" : "les séances" }}
            </button>
          </td>
        </tr>
      </tfoot>
    </table>

    <modal
      title="Attribuer"
      v-model="editDone"
      cancelText="Annuler"
      okText="Valider"
      @ok="handleSaveDone"
      effect="fade/zoom"
    >
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Marquer la séance comme</h4>
        <el-select v-model="form.type">
          <el-option key="validee" value="validee" label="Validée" />
          <el-option key="planifiee" value="planifiee" label="Planifiée" />
          <el-option
            key="non-programmee"
            value="non-programmee"
            label="Non programmée"
          />
        </el-select>
      </div>
      <div
        class="row"
        v-if="form.type === 'validee' || form.type === 'planifiee'"
      >
        <div class="form-group col-sm-6">
          <label v-if="form.type === 'validee'"
            >La séance a été faite à la date</label
          >
          <label v-else>Séance planifiée pour le</label>
          <datepicker
            v-model="form.doneAt"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
        <div class="form-group col-sm-3">
          <label>Heures</label>
          <select class="form-control" v-model="form.doneHour">
            <option v-for="hour in 22" :key="hour - 1" :value="hour - 1">
              {{ 10 > hour - 1 ? `0${hour - 1}` : hour - 1 }}
            </option>
          </select>
        </div>
        <div class="form-group col-sm-3">
          <label>Minutes</label>
          <select class="form-control" v-model="form.doneMinute">
            <option v-for="min in 60" :key="min - 1" :value="min - 1">
              {{ 10 > min - 1 ? `0${min - 1}` : min - 1 }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mt-1" v-if="form.type === 'validee'">
        <div class="form-group col-sm-12">
          <label class="switch switch-sm switch-text switch-info mb-0">
            <input
              type="checkbox"
              class="switch-input"
              v-model="form.clientEmail"
            />
            <span class="switch-label" data-on="On" data-off="Off"></span>
            <span class="switch-handle"></span>
          </label>
          Envoyer un email pour prévenir le client ?
        </div>
      </div>
    </modal>

    <modal
      title="Modifier"
      v-model="editDate"
      cancelText="Annuler"
      okText="Modifier"
      @ok="handleEditDate"
      effect="fade/zoom"
    >
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title" v-if="editDateType === 'assignedAt'">
          Modifier la date d'attribution
        </h4>
        <h4 class="modal-title" v-if="editDateType === 'scheduledAt'">
          Modifier la date de programmation
        </h4>
      </div>
      <div class="row">
        <div class="form-group col-sm-8">
          <label v-if="editDateType === 'assignedAt'"
            >La séance a été attribuée à la date</label
          >
          <label v-if="editDateType === 'scheduledAt'"
            >La séance a été programmée à la date</label
          >
          <datepicker
            v-model="form.doneAt"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
        <div class="form-group col-sm-2">
          <label>Heures</label>
          <input class="form-control" type="text" v-model="form.doneHour" />
        </div>
        <div class="form-group col-sm-2">
          <label>Minutes</label>
          <input class="form-control" type="text" v-model="form.doneMinute" />
        </div>
      </div>
      <div>
        <button
          class="btn btn-danger btn-sm"
          @click="saveUnschedule(editSession)"
          v-if="editDateType === 'scheduledAt' && !editSession.completed"
        >
          Annuler la programmation de la séance
        </button>
        <button
          class="btn btn-danger btn-sm"
          @click="saveUnassign(editSession)"
          v-if="editDateType === 'assignedAt' && !editSession.scheduledAt"
        >
          Annuler l'attribution de la séance
        </button>
      </div>
    </modal>

    <modal
      title="Modifier"
      v-model="editSelected"
      cancelText="Annuler"
      okText="Modifier"
      @ok="handleEditSelected"
      effect="fade/zoom"
      class="bulk-edit-modal"
      large
      :backdrop="false"
    >
      <div slot="modal-header" class="modal-header">
        <h4 v-if="selected.length === 1">Modifier la séance</h4>
        <h4 v-else>Modifier les {{ selected.length }} séances</h4>
      </div>

      <div v-if="remainingSessions" class="row">
        <div class="col-sm-12">
          <div class="alert alert-warning">
            Il reste {{ remainingSessions }} séance(s) à attribuer
          </div>
        </div>
      </div>

      <div v-if="errors.groups" class="row">
        <div class="col-sm-12">
          <div class="alert alert-warning">
            {{ errors.groups }}
          </div>
        </div>
      </div>

      <div
        :key="`form-groups-${index}`"
        v-for="(group, index) of form.bulkEditGroups"
        class="row mb-1"
      >
        <hr v-if="index !== 0" style="width: 95%" />
        <div class="col-sm-4">
          <p><strong>Coachs</strong></p>
          <v-select
            :options="coachsOpt"
            v-model="group.coachs"
            v-if="coachsOpt"
            multiple
          ></v-select>
        </div>
        <div class="col-sm-3">
          <p><strong>Avoir</strong></p>
          <input class="form-control" type="text" v-model="group.credit" />
        </div>
        <div class="col-sm-2">
          <p>
            <strong>Nb. de séances</strong>
          </p>
          <input
            class="form-control"
            type="number"
            v-model="group.countSession"
            min="0"
            :max="selected.length"
            step="1"
            @change="checkSessionNumber(index)"
          />
        </div>
        <div class="col-sm-2 d-flex flex-column align-items-center">
          <p><strong>Modifier statut</strong></p>
          <label
            class="switch switch-sm switch-text switch-info"
            style="margin-top: 0.5rem"
          >
            <input
              type="checkbox"
              class="switch-input"
              v-model="group.editStatus"
            />
            <span class="switch-label" data-on="On" data-off="Off"></span>
            <span class="switch-handle"></span>
          </label>
        </div>
        <div
          class="col-sm-1"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <button class="btn-no-style text-primary" @click="addFormGroup">
            <i class="fa fa-plus-circle"></i>
          </button>
          <button
            class="btn-no-style text-danger"
            @click="removeFormGroup(index)"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
        <template v-if="group.editStatus">
          <div class="col-sm-4 mt-1">
            <p><strong>Statut</strong></p>
            <v-select
              :options="typeOpts"
              v-model="group.type"
              :reduce="(option) => option.value"
            ></v-select>
          </div>
          <template v-if="group.type && group.type !== 'non-programmee'">
            <div class="form-group col-sm-3 mt-1">
              <p>
                <strong>{{
                  group.type === "validee" ? "Fait le" : "Pour le"
                }}</strong>
              </p>
              <datepicker
                v-model="group.doneAt"
                format="dd.MM.yyyy"
                language="fr"
                input-class="form-control"
              ></datepicker>
            </div>
            <div class="form-group col-sm-2 mt-1">
              <p><strong>Heure</strong></p>
              <select class="form-control" v-model="group.doneHour">
                <option v-for="hour in 22" :key="hour - 1" :value="hour - 1">
                  {{ 10 > hour - 1 ? `0${hour - 1}` : hour - 1 }}
                </option>
              </select>
            </div>
            <div class="form-group col-sm-2 mt-1">
              <p><strong>Minute</strong></p>
              <select class="form-control" v-model="group.doneMinute">
                <option v-for="min in 60" :key="min - 1" :value="min - 1">
                  {{ 10 > min - 1 ? `0${min - 1}` : min - 1 }}
                </option>
              </select>
            </div>
          </template>
        </template>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <p>
            <small>
              <em> Attention, un avoir ou coachs vide = suppression </em>
            </small>
          </p>
        </div>
      </div>
    </modal>

    <modal
      title="Envoyer les liens"
      v-model="showVisioLinkModal"
      effect="fade/zoom"
    >
      <div slot="modal-body" class="modal-body">
        <div class="alert alert-danger" role="alert">
          Attention ! Cela enverra un email avec le lien visio.
        </div>
      </div>
      <div
        slot="modal-footer"
        class="modal-footer d-flex justify-content-between"
      >
        <button
          type="button"
          class="btn btn-default mr-1"
          @click="showVisioLinkModal = false"
        >
          Annuler
        </button>
        <button type="button" class="btn btn-info" @click="sendLink('user')">
          Envoyer à l'utilisateur
        </button>
        <button type="button" class="btn btn-info" @click="sendLink('admin')">
          Envoyer au coach
        </button>
      </div>
    </modal>

    <SessionSignatureSheetModal
      :session="displaySessionSignatureSheet"
      @updated="sessionSignatureSheetUpdated"
      @close="displaySessionSignatureSheet = null"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import Modal from "vue-strap/src/Modal";
import Datepicker from "vuejs-datepicker";
import SignatureSheetStatusBadge from "@/components/company/SignatureSheetStatusBadge";
import SessionSignatureSheetModal from "@/components/company/SessionSignatureSheetModal";
import SignatureSheetDownloadButton from "@/components/company/SignatureSheetDownloadButton";

import moment from "moment";

export default {
  components: {
    vSelect,
    Modal,
    Datepicker,
    SignatureSheetStatusBadge,
    SessionSignatureSheetModal,
    SignatureSheetDownloadButton,
  },
  props: {
    sessionsData: {
      type: Array,
      default: null,
    },
    visio: {
      type: Boolean,
      default: false,
    },
    coachs: {
      type: Object,
      default: null,
    },
    coach: {
      type: Object,
      default: null,
    },
    client: {
      type: Boolean,
      default: false,
    },
    disableEdition: {
      type: Boolean,
      default: false,
    },
    showNbOfParticipants: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sessions: [],
      coachsId: null,
      coachsOpt: null,
      editCoachs: false,
      editCoachsTimeout: null,
      editCredit: false,
      editDuration: false,
      editDone: false,
      editDate: false,
      editSelected: false,
      editSession: null,
      editDateType: null,
      form: {
        type: "validee",
        doneAt: null,
        doneHour: null,
        doneMinute: null,
        bulkEditGroups: [
          {
            coachs: null,
            credit: "0",
            countSession: 0,
            editStatus: false,
            type: null,
            doneAt: null,
            doneHour: null,
            doneMinute: null,
          },
        ],
        clientEmail: false,
        duration: "01:00",
        multiple: false,
      },
      errors: {
        groups: null,
      },
      selected: [],
      bookingsModal: {
        show: false,
        bookings: [],
      },
      ratingsModal: {
        show: false,
        session: null,
      },
      typeOpts: [
        {
          label: "Validée",
          value: "validee",
        },
        {
          label: "Planifiée",
          value: "planifiee",
        },
        {
          label: "Non programmée",
          value: "non-programmee",
        },
      ],
      showVisioLinkModal: false,
      currentSession: null,
      displaySessionSignatureSheet: null,
    };
  },

  computed: {
    remainingSessions() {
      let remainingSessions = this.selected.length;

      this.form.bulkEditGroups.forEach((c) => {
        remainingSessions = remainingSessions - c.countSession;
      });

      return remainingSessions;
    },

    oneOrMoreHasSignatureSheet() {
      return this.sessions.some((session) => !!session.signatureSheet);
    },
  },

  async created() {
    if (!this.coachs) {
      const { data } = await this.$api.get("/users/coachs");

      this.coachsId = data.map((c) => ({
        label: c.coach.name,
        value: c.id,
      }));
      this.coachsOpt = data.map((c) => ({
        label: c.coach.name,
        value: c.email,
      }));
    } else {
      this.coachsId = this.coachs.map((c) => ({
        label: c.coach.name,
        value: c.id,
      }));
      this.coachsOpt = this.coachs.map((c) => ({
        label: c.coach.name,
        value: c.email,
      }));
    }
  },

  watch: {
    sessionsData() {
      if (this.sessionsData) {
        this.sessions = [...this.sessionsData];
      }
    },
  },

  mounted() {
    if (this.sessionsData) {
      this.sessions = [...this.sessionsData];
    }
  },

  methods: {
    sessionCoachs(sessionId) {
      const names = [];

      this.sessions
        .find((s) => s.id === sessionId)
        ?.coachs.forEach((coach) => {
          names.push({
            label: coach.coach.name,
            value: coach.id,
          });
        });

      return names;
    },

    toggleSelected(event) {
      if (this.selected.length && !event.target.checked) {
        this.selected = [];
      } else {
        this.selected = this.sessions
          .filter((s) => !s.completed)
          .map((s) => s.id);
      }
    },

    handleRemoveSession() {
      this.selected.forEach((sessionId, index) => {
        const session = this.sessions.find((s) => s.id === sessionId);

        if (session.completed || session.scheduledAt) {
          this.selected.splice(index, 1);
        }
      });

      if (this.selected.length === 0) {
        return false;
      }

      this.$confirm({
        message: `Attention, ${this.selected.length} séance${
          this.selected.length > 1
            ? "s vont être supprimées"
            : " va être supprimée"
        } définitivement de la commande !`,
        onConfirm: async () => {
          const session = this.sessions.find((s) => s.id === this.selected[0]);

          await this.$api.delete(`/sessions/${session.orderId}`, {
            data: {
              sessions: this.selected,
            },
          });

          window.location.reload(true);
        },
      });
    },

    editScheduledDate(session) {
      if (session.scheduledAt) {
        this.editSession = session;
        this.editDate = true;
        this.editDateType = "scheduledAt";
        this.form.doneAt = moment(session.scheduledAt).format("YYYY-MM-DD");
        this.form.doneHour = moment(session.scheduledAt).format("HH");
        this.form.doneMinute = moment(session.scheduledAt).format("mm");
      }
    },

    editAssignedDate(session) {
      if (session.assignedAt) {
        this.editSession = session;
        this.editDate = true;
        this.editDateType = "assignedAt";
        this.form.doneAt = moment(session.assignedAt).format("YYYY-MM-DD");
        this.form.doneHour = moment(session.scheduledAt).format("HH");
        this.form.doneMinute = moment(session.scheduledAt).format("mm");
      }
    },

    handleEditDate() {
      this.$api
        .put("/sessions/date/" + this.editSession.id, {
          dateAt: this.form.doneAt,
          dateHour: this.form.doneHour + ":" + this.form.doneMinute,
          dateType: this.editDateType,
        })
        .then(() => {
          window.location.reload(true);
        });
    },

    handleEditSelected() {
      if (this.errors.groups) {
        this.errors.groups = null;
      }

      const editGroups = this.form.bulkEditGroups
        .filter((group) => group.coachs?.length > 0)
        .filter((group) => group.credit && group.credit !== "")
        .filter((group) => group.countSession > 0)
        .filter((group) => {
          if (group.editStatus) {
            return (
              group.type &&
              (group.type === "non-programmee" ||
                ((group.type === "validee" || group.type === "planifiee") &&
                  group.doneAt &&
                  (group.doneHour || group.doneHour === 0) &&
                  (group.doneMinute || group.doneMinute === 0) &&
                  Number.isInteger(group.doneHour) &&
                  Number.isInteger(group.doneMinute)))
            );
          }

          return true;
        })
        .map((group) => ({
          credit: parseInt(
            parseFloat(group.credit.trim().replace(",", ".")) * 100,
          ),
          coachs: group.coachs.map((c) => c.value),
          countSession: group.countSession,
          editStatus: group.editStatus,
          type: group.type,
          doneAt: group.doneAt,
          doneHour:
            (group.doneHour || group.doneHour === 0) &&
            (group.doneMinute || group.doneMinute === 0) &&
            `${group.doneHour}:${group.doneMinute}`,
        }));

      if (editGroups.length === 0) {
        this.errors.groups = "Tous les champs doivent être remplis";

        return false;
      }

      this.$confirm({
        message: "Confirmer la modification des séances ?",
        onConfirm: async () => {
          await this.$api.put("/sessions/bulk", {
            sessions: this.selected,
            editGroups,
          });

          window.location.reload();
        },
      });
    },

    async saveCoachs(values) {
      let session = this.sessions.find((s) => s.id === this.editCoachs);

      if (!session || values.length === session.coachs.length) {
        return;
      }

      await this.$api
        .put(`/sessions/${session.id}/coachs`, {
          coachs: values.map((opt) => opt.value),
        })
        .then((res) => {
          this.$set(session, "coachs", res.data);

          if (res.data && res.data.length > 0 && !session.assignedAt) {
            this.$set(session, "assignedAt", moment().format());
          }
        });

      this.$emit("change-coach");
    },

    saveDone(session) {
      if (!this.hasPermission(this.$store.state.user, "SESSIONS_WRITE")) {
        return;
      }

      if (
        session.coachs.length !== 1 &&
        !this.isAdmin(this.$store.state.user)
      ) {
        this.$errorToast(
          "Pour valider manuellement une séance, un seul coach doit être assigné",
        );

        return;
      }

      if (session.scheduledAt) {
        this.form.doneHour = parseInt(moment(session.scheduledAt).format("HH"));
        this.form.doneMinute = parseInt(
          moment(session.scheduledAt).format("mm"),
        );
        this.form.doneAt = moment(session.scheduledAt).format("YYYY-MM-DD");
      }

      this.editSession = session;
      this.editDone = true;
      this.form.multiple = false;
      this.form.type = session.completed
        ? "validee"
        : session.scheduledAt
        ? "planifiee"
        : "non-programmee";
    },

    saveUnschedule(session) {
      this.$confirm({
        message: "Annuler la programmation de la séance ?",
        onConfirm: async () => {
          await this.$api.put(`/sessions/undone/${session.id}`);

          window.location.reload(true);
        },
      });
    },

    saveUnassign(session) {
      this.$confirm({
        message: "Annuler l'attribution de la séance ?",
        onConfirm: async () => {
          await this.$api.put(`/sessions/undone/${session.id}`);

          window.location.reload(true);
        },
      });
    },

    saveCredit(e) {
      if (this.editCredit) {
        const session = this.sessions.find((s) => s.id === this.editCredit);

        const value = this.formatFormPrice(e.target.value.trim());

        if (isNaN(parseFloat(value))) {
          return;
        }

        session.credit = parseInt(parseFloat(value) * 100);

        if (session.credit >= 7000) {
          this.$confirm({
            message:
              "Attention, le crédit saisi est anormalement élevé. Confirmer ?",
            onConfirm: async () => {
              this.$api
                .put(`/sessions/${session.id}/credit`, {
                  credit: session.credit,
                })
                .then(() => {
                  this.editCredit = false;
                  this.$successToast("Crédit mis à jour");
                });
            },
          });
        } else {
          this.$api
            .put(`/sessions/${session.id}/credit`, {
              credit: session.credit,
            })
            .then(() => {
              this.editCredit = false;
              this.$successToast("Crédit mis à jour");
            });
        }
      }
    },

    saveDuration(e) {
      if (this.editDuration) {
        let date = moment(e, "HH:mm");

        const session = this.sessions.find((s) => s.id === this.editDuration);
        session.duration =
          parseInt(date.format("HH")) * 60 + parseInt(date.format("mm"));

        this.$api
          .put("/sessions/" + session.id + "/duration", {
            duration: session.duration,
          })
          .then(() => {
            this.editDuration = false;
          });
      }
    },

    async handleSaveDone() {
      if (
        (this.form.type === "validee" || this.form.type === "planifiee") &&
        (!Number.isInteger(this.form.doneHour) ||
          !Number.isInteger(this.form.doneMinute) ||
          !this.form.doneAt)
      ) {
        this.$errorToast("Tous les champs sont obligatoires.");

        return;
      }

      await this.$api.put("/sessions/done/" + this.editSession.id, {
        type: this.form.type,
        doneAt: this.form.doneAt,
        doneHour: this.form.doneHour + ":" + this.form.doneMinute,
        clientEmail: this.form.clientEmail,
      });

      window.location.reload(true);
    },

    clickHandler(session) {
      this.$emit("click", session);
    },

    addFormGroup() {
      this.form.bulkEditGroups.push({
        coachs: null,
        credit: 0,
        countSession: 0,
      });
    },

    removeFormGroup(index) {
      this.form.bulkEditGroups = this.form.bulkEditGroups.filter(
        (item, idx) => {
          return idx !== index;
        },
      );

      if (this.form.bulkEditGroups.length === 0) {
        this.addFormGroup();
      }
    },

    checkSessionNumber(index) {
      if (parseInt(this.form.bulkEditGroups[index].countSession) < 0) {
        this.form.bulkEditGroups[index].countSession = 0;
      } else {
        const otherGroups = this.form.bulkEditGroups.filter(
          (group, i) => i !== index,
        );

        let alreadyAttributed = 0;

        otherGroups.forEach((group) => {
          alreadyAttributed += parseInt(group.countSession);
        });

        const max = this.selected.length - alreadyAttributed;

        if (parseInt(this.form.bulkEditGroups[index].countSession) > max) {
          this.form.bulkEditGroups[index].countSession = max;
        } else {
          this.form.bulkEditGroups[index].countSession = parseInt(
            this.form.bulkEditGroups[index].countSession,
          );
        }
      }
    },

    openRatingsModal(session) {
      this.ratingsModal.session = session;
      this.ratingsModal.show = true;
    },

    closeRatingsModal() {
      this.ratingsModal.show = false;
      this.ratingsModal.session = null;
    },

    async changeSessionNbOfParticipants(value, session) {
      if (isNaN(parseInt(value))) {
        session.nbOfParticipants = null;

        return;
      }

      try {
        const nbOfParticipants = parseInt(value);

        await this.$api.put(`/sessions/${session.id}/nb-of-participants`, {
          nbOfParticipants,
        });

        session.nbOfParticipants = nbOfParticipants;
      } catch (e) {
        session.nbOfParticipants = null;
      }
    },

    async unlockSessionCoach(session) {
      this.$confirm({
        message:
          "Voulez-vous débloquer cette séance ? Attention cette action est irréversible.",
        onConfirm: async () => {
          const { status } = await this.$api.patch(
            `/sessions/${session.id}/unlock-coach-session`,
          );

          if (status === 200) {
            session.sessionCoachBlocked = false;
            this.$successToast("La séance a bien été débloquée.");
          }
        },
      });
    },

    coachsLinks(session) {
      const links = [];

      if (session.coachs) {
        session.coachs.forEach((coach) => {
          links.push(coach.coach.name);
        });
      }

      return links.join("<br>");
    },

    async handleSendVisioLink(session) {
      this.currentSession = session;
      this.showVisioLinkModal = true;
    },

    async sendLink(type) {
      try {
        if (!this.currentSession) {
          return;
        }

        await this.$api.patch(
          `/sessions/${this.currentSession.id}/visio/${type}/send-link`,
        );

        this.$successToast("Le lien à bien été envoyé.");
      } catch (e) {
        this.$errorToast("Une erreur est survenue lors de l'envoi des liens'.");
      }

      this.showVisioLinkModal = false;
    },

    sessionSignatureSheetUpdated({ sessionId, signatureSheetData }) {
      this.sessions = this.sessions.map((s) => {
        if (s.id === sessionId) {
          return {
            ...s,
            signatureSheet: s.signatureSheet
              ? {
                  ...s.signatureSheet,
                  ...signatureSheetData,
                }
              : signatureSheetData,
          };
        }

        return s;
      });
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.btn-no-style {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: 0;
}

.btn-no-style:focus-visible,
.btn-no-style:focus {
  outline: 0;
}

.border-danger {
  border: 1px solid red;
  border-radius: 5px;
  padding: 2px 4px;
}

.overflow-x-auto {
  overflow-x: auto;
}

.bulk-edit-modal .v-select input[type="search"] {
  width: 0 !important;
}
</style>
